import { UiMode } from './uiMode';
import { SM } from './storeModel.enum';

export const NavMenu = [
  {
    order: 0,
    type: 'item_left',
    label: 'navbar.item0',
    iconClass: 'fa-solid fa-gauge',
    hrefLink: null,
    routerLink: '/auth/dashboard',
    storeModel: SM.SM_DASHBOARD,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 1,
    type: 'item_left',
    label: 'navbar.item1',
    iconClass: 'fa-kit fa-fields',
    hrefLink: null,
    routerLink: '/auth/fields/list',
    storeModel: SM.SM_FIELD,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 1,
    type: 'item_left',
    label: 'navbar.stables',
    iconClass: 'fa-kit fa-stables',
    hrefLink: null,
    routerLink: '/auth/stables/list',
    storeModel: SM.SM_STABLE,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.animals',
    iconClass: 'fa-kit fa-livestock',
    hrefLink: null,
    routerLink: '/auth/animals/list',
    storeModel: SM.SM_ANIMAL,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.item3',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/stable-activity/list',
    storeModel: SM.SM_STABLEACTIVITY,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.item2',
    iconClass: 'glyphicon glyphicon-map-marker',
    hrefLink: null,
    routerLink: '/auth/map',
    storeModel: SM.SM_MAP,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 3,
    type: 'item_left',
    label: 'navbar.item3',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/activities/list',
    storeModel: SM.SM_FIELDACTIVITY,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 4,
    type: 'item_left',
    label: 'navbar.weather',
    iconClass: 'fa-kit fa-weather',
    hrefLink: null,
    routerLink: '/auth/weather/dashboard',
    storeModel: SM.SM_WEATHER_FREE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 5,
    type: 'item_left',
    label: 'navbar.item4',
    iconClass: 'fa-kit fa-sensors',
    hrefLink: null,
    routerLink: '/auth/sensors/dashboard',
    storeModel: SM.SM_SENSOR,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 6,
    type: 'item_left',
    label: 'navbar.rations',
    iconClass: 'fa-kit fa-ration',
    hrefLink: null,
    routerLink: '/rations/dashboard',
    storeModel: SM.SM_RATIONS,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
  },
  {
    order: 7,
    type: 'item_left',
    label: 'navbar.item6_1',
    iconClass: 'fa-kit fa-custom-warehouse',
    hrefLink: null,
    routerLink: '/auth/containers/list',
    storeModel: SM.SM_WAREHOUSE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 8,
    type: 'item_left',
    label: 'navbar.item5',
    iconClass: 'fa-solid fa-note-sticky',
    hrefLink: null,
    routerLink: '/auth/notes/list',
    storeModel: SM.SM_NOTE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 9,
    type: 'item_left',
    label: 'navbar.products',
    iconClass: 'fa-kit fa-product',
    hrefLink: null,
    routerLink: '/auth/products/list',
    storeModel: SM.SM_PRODUCT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 10,
    type: 'item_left',
    label: 'navbar.item6_2',
    iconClass: 'fa-kit fa-loads',
    hrefLink: null,
    routerLink: '/auth/loads/list',
    storeModel: SM.SM_LOAD,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 10,
    type: 'item_left',
    label: 'navbar.item6_2',
    iconClass: 'fa-kit fa-loads',
    hrefLink: null,
    routerLink: '/auth/stable-loads/list',
    storeModel: SM.SM_STABLE_LOAD,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
  },
  {
    order: 11,
    type: 'item_left',
    label: 'navbar.item6_6',
    iconClass: 'fa-kit fa-silos',
    hrefLink: null,
    routerLink: '/auth/silos/list',
    storeModel: SM.SM_SILOS,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 12,
    type: 'item_left',
    label: 'navbar.item6_3',
    iconClass: 'fa-kit fa-machinery',
    hrefLink: null,
    routerLink: '/auth/equipments/list',
    storeModel: SM.SM_EQUIPMENT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 13,
    type: 'item_left',
    label: 'navbar.cropPlanning',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/crop-planning/plans',
    storeModel: SM.SM_CROP_PLANNING,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 14,
    type: 'item_left',
    label: 'navbar.batchs',
    iconClass: 'fas fa-archive',
    hrefLink: null,
    routerLink: '/auth/batchs/list',
    storeModel: SM.SM_BATCH,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 16,
    type: 'item_left',
    label: 'navbar.item9',
    iconClass: 'fa-kit fa-custom-satellite',
    hrefLink: null,
    routerLink: '/auth/satellite/dashboard',
    storeModel: SM.SM_SATELLITE_FREE,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 17,
    type: 'item_left',
    label: 'navbar.analysis',
    iconClass: 'fa-solid fa-map',
    hrefLink: null,
    routerLink: '/auth/satellite/manage-files',
    storeModel: SM.SM_PRECISIONFARMING,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 18,
    type: 'item_left',
    label: 'navbar.item6_5',
    iconClass: 'glyphicon glyphicon-bell',
    hrefLink: null,
    routerLink: '/auth/alerts/list',
    storeModel: SM.SM_ALERT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 19,
    type: 'item_left',
    label: 'navbar.irrigating',
    iconClass: 'fa-solid fa-droplet',
    hrefLink: null,
    routerLink: '/auth/irrigation',
    storeModel: SM.SM_IRRIGATION,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 20,
    type: 'item_left',
    label: 'navbar.financial',
    iconClass: 'fa-solid fa-coins',
    hrefLink: null,
    routerLink: '/auth/financials/dashboard',
    storeModel: SM.SM_FINANCE,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 21,
    type: 'item_left',
    label: 'navbar.diseases',
    iconClass: 'fa-solid fa-shield-halved',
    hrefLink: null,
    routerLink: '/auth/diseases/dashboard',
    storeModel: SM.SM_PATHOGEN,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 22,
    type: 'item_left',
    label: 'navbar.overview',
    iconClass: 'fa-solid fa-gauge',
    hrefLink: null,
    routerLink: '/auth/overview',
    storeModel: SM.SM_ANALYTICS_OVERVIEW,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 23,
    type: 'item_left',
    label: 'navbar.chain-management',
    iconClass: 'fas fa-chart-line',
    hrefLink: null,
    routerLink: '/auth/chain-management',
    storeModel: SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 24,
    type: 'item_left',
    label: 'navbar.sustainability',
    iconClass: 'fa-solid fa-hand-holding-seedling',
    hrefLink: null,
    routerLink: '/auth/sustainability',
    storeModel: SM.SM_ANALYTICS_IMPACT,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 25,
    type: 'item_left',
    label: 'navbar.operationsManagement',
    iconClass: 'fa-kit fa-operational',
    hrefLink: null,
    routerLink: '/auth/operation-management',
    storeModel: SM.SM_OPERATION_MANAGEMENT,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 26,
    type: 'item_left',
    label: 'navbar.taskplan',
    iconClass: 'fa-solid fa-calendar-days',
    hrefLink: null,
    routerLink: '/auth/task-plan/show',
    storeModel: SM.SM_WORK_PLANNING,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 27,
    type: 'item_left',
    label: 'navbar.agrirouter',
    iconClass: 'fa-kit fa-machinery',
    hrefLink: null,
    routerLink: '/auth/task-viewer',
    storeModel: SM.SM_EQUIPMENT_TELEMETRY,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 28,
    type: 'item_left',
    label: 'navbar.farm_sustainability',
    iconClass: 'fa-solid fa-hand-holding-seedling',
    hrefLink: null,
    routerLink: '/auth/sustainability/dashboard',
    storeModel: SM.SM_SUSTAINABILITY,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
  },
  {
    order: 29,
    type: 'item_left',
    label: 'navbar.insects',
    iconClass: 'fa-kit fa-insects',
    hrefLink: null,
    routerLink: '/auth/insects',
    storeModel: SM.SM_INSECTS,
    children: null,
    enableModeList: [UiMode.FARM],
  },
  {
    order: 30,
    type: 'item_left',
    label: 'navbar.farm_dossier',
    iconClass: 'fas fa-book',
    hrefLink: null,
    routerLink: '/farm-dossier/dash-board',
    storeModel: SM.SM_FARM_DOSSIER,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 31,
    type: 'item_left',
    label: 'navbar.export_document',
    iconClass: 'fas fa-cloud-download-alt',
    hrefLink: null,
    routerLink: '/auth/import-export/export',
    storeModel: SM.SM_EXPORT_FREE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  // {
  //     order: 30,
  //     type: 'item_left',
  //     label: 'map_control_center.control_center',
  //     iconClass: 'glyphicon glyphicon-map-marker',
  //     hrefLink: null,
  //     routerLink: '/auth/map-control-center',
  //     storeModel: SM.SM_MAP,
  //     children: null
  // },
  {
    order: 29,
    type: 'item_right',
    label: null,
    iconClass: 'glyphicon glyphicon-shopping-cart',
    hrefLink: 'https://xfarm.ag/versioni-e-prezzi/',
    routerLink: null,
    storeModel: SM.SM_SHOP,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
  },
  {
    order: 33,
    type: 'item_left',
    label: 'navbar.checks',
    iconClass: 'fa-solid fa-file-circle-check',
    hrefLink: null,
    routerLink: '/checks',
    storeModel: SM.SM_CHECKS,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
  },
  {
    order: 30,
    type: 'dropdown_right',
    label: null,
    iconClass: 'glyphicon glyphicon-user',
    routerLink: null,
    storeModel: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    children: [
      {
        order: 0,
        type: 'item_left',
        label: 'navbar.item7_3',
        iconClass: 'fa fa-question-circle',
        hrefLink: 'https://www.xfarm.ag/tutorials/',
        routerLink: null,
        storeModel: SM.SM_GUIDE,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
      },
      {
        order: 1,
        type: 'item_left',
        label: 'navbar.item7_1w',
        iconClass: 'fa-kit fa-product',
        hrefLink: null,
        routerLink: '/auth/welcome/farm',
        storeModel: null,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
      },
      {
        order: 2,
        type: 'item_left',
        label: 'navbar.item7_1',
        iconClass: 'fa-kit fa-settings',
        hrefLink: null,
        routerLink: '/auth/company-data',
        storeModel: SM.SM_SETTING,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
      },
      {
        order: 3,
        type: 'item_left',
        label: 'navbar.shared',
        iconClass: 'fas fa-share-square',
        hrefLink: null,
        routerLink: '/auth/sharing',
        storeModel: SM.SM_SETTING,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
      },
    ],
  },
];
